import { useTranslation } from "react-i18next";

import { Accordion } from "@/components/Interface/Accordion/Accordion";
import { RoamingUsage } from "@/components/Portal/DeviceManagement/Roaming/ShowRoamingOptions/RoamingUsage/RoamingUsage";
import { useBookedRoamingOptionDisplay } from "@/components/Portal/DeviceManagement/Roaming/ShowRoamingOptions/useBookedRoamingOptionDisplay";
import { RoamingInfo, SimCardDetail } from "@/services/model";
import { TOTAL_DAYS_IN_YEAR } from "@/utils/constants";

interface Props {
  roamingInfo: RoamingInfo;
  simDetail: SimCardDetail;
  index: number;
  isFirstOfUsageZone: boolean;
  defaultOpen: boolean;
}

/** One row of the "Gebuchte Pakete" list: a booked travel roaming package. */
export const TravelPackageAccordionItem = ({
  roamingInfo,
  simDetail,
  index,
  isFirstOfUsageZone,
  defaultOpen,
}: Props) => {
  const { t } = useTranslation("portal");
  const { title, flatName, hasIncludedRoamingCalls, shouldTreatAsActive } =
    useBookedRoamingOptionDisplay(roamingInfo, simDetail, index);

  return (
    <div data-testid="roaming-option" className="w-full">
      <Accordion
        className="w-full"
        defaultOpen={defaultOpen}
        label={`${title} - ${flatName}`}
      >
        <div className="flex w-full flex-col gap-4">
          <RoamingUsage
            days={roamingInfo.remainingDays || 0}
            description="cockpit.managementTile.roaming.showOption.active.remainingData"
            initial={roamingInfo.initialVolume || 0}
            isFirstOfUsageZone={isFirstOfUsageZone}
            remaining={roamingInfo.remainingVolume || 0}
            consumed={
              (roamingInfo.initialVolume || 0) -
              (roamingInfo.remainingVolume || 0)
            }
            isIncludedInService={roamingInfo.includedInService}
            roamingStatus={roamingInfo.roamingStatus}
            title={t("cockpit.managementTile.roaming.card.dataUsageGeneric")}
            isYearly={roamingInfo.initialDays === TOTAL_DAYS_IN_YEAR}
            shouldTreatAsActive={shouldTreatAsActive}
            hasIncludedRoamingCalls={hasIncludedRoamingCalls}
            zone={roamingInfo.usageZone}
            isDataUsage={true}
          />

          <RoamingUsage
            days={roamingInfo.remainingDays || 0}
            description="cockpit.managementTile.roaming.showOption.active.runtimeUsage"
            initial={roamingInfo.initialDays || 0}
            remaining={roamingInfo.remainingDays || 0}
            roamingStatus={roamingInfo.roamingStatus}
            title={t(
              "cockpit.managementTile.roaming.showOption.active.runtime",
            )}
            isFirstOfUsageZone={isFirstOfUsageZone}
            shouldTreatAsActive={shouldTreatAsActive}
            hasIncludedRoamingCalls={hasIncludedRoamingCalls}
          />
        </div>
      </Accordion>
    </div>
  );
};
